import { useAuth } from '../../context/AuthContext';

const APP_VERSION = '1.0.0';
const HEYKIKI_APP_VERSION = '2.0.0';

function Footer() {
  const { user } = useAuth();
  const isHeykikiOrg = user?.organisation?.orgType === 'HEYKIKI';

  return (
    <footer className="bg-surface border-t border-border mt-auto">
      <div className="container mx-auto px-6 py-4">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-sm text-text-muted">
          {isHeykikiOrg ? (
            <div className="flex items-center gap-2">
              <span>HeyKiki v{HEYKIKI_APP_VERSION}</span>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <img
                src="/icons/footerwerkpilot.png"
                alt="WerkPilot"
                className="h-5 w-auto"
              />
              <span>WerkPilot v{APP_VERSION}</span>
            </div>
          )}
          <div>
            &copy; 2026 {isHeykikiOrg ? 'All rights reserved.' : 'HermanAI Solutions. All rights reserved.'}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
